import { PureDataMarkerProps } from '@weenat/client/dist/core/map'
import { BoxProps } from 'app/src/kit/primitives/themeMappings/props'
import { memo } from 'react'
import PureDataMarker from './PureDataMarker'

interface DiscreteDataMarkerProps {
  type: PureDataMarkerProps['type']
  isFocused?: PureDataMarkerProps['isFocused']
  boxShadow?: BoxProps['$boxShadow']
  hideAnchor?: PureDataMarkerProps['hideAnchor']
}

/**
 * Discrete marker — shown when the resource does not support the currently
 * selected metric. Renders as a solid-black icon with no value label.
 */
const DiscreteDataMarker: FC<DiscreteDataMarkerProps> = ({
  type,
  isFocused,
  boxShadow,
  hideAnchor
}) => (
  <PureDataMarker
    backgroundColor='black'
    color='grayscale.white'
    content={null}
    trend={undefined}
    showLastUpdate={false}
    lastUpdate={undefined}
    showStatusIndicator={false}
    status={undefined}
    type={type}
    showContent={false}
    isFocused={isFocused}
    boxShadow={boxShadow}
    hideAnchor={hideAnchor}
    iconSize='md'
    opacity={0.75}
    timezone={undefined}
  />
)

export default memo(DiscreteDataMarker)
